import {
  IconArrowAutofitRight,
  IconBuildingStore,
  IconChevronLeft,
  IconChevronRight,
  IconPlus,
  IconRefresh,
  IconSearch, IconCalendarTime,
  IconWallet,
  IconFilter,
  IconArrowUpRight,
  IconArrowDownRight,
  IconArrowsExchange,
  IconX,
  IconEye,
  IconReceiptTax,
  IconCheck,
} from '@tabler/icons-react';
import { Dialog, Transition } from '@headlessui/react';
import { Tooltip } from 'antd';
import { Fragment, useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAuthorizationHeader, http } from '../config/http';
import moment from "moment";
import { DateRange } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import Layouts from '../layouts/Layouts';
import { DinamicTitle } from '../utils/DinamicTitle';
import DetailSaldoKas from './DetailSaldoKas';
import TambahSaldoKAS from './TambahSaldoKAS';

const getTipeBadge = (tipe) => {
  switch (tipe) {
    case 'Penjualan':
      return {
        label: 'Penjualan',
        className:
          'bg-emerald-50 text-emerald-700 dark:bg-emerald-950/50 dark:text-emerald-300 border border-emerald-200 dark:border-emerald-800/70',
        icon: <IconArrowUpRight size={13} className="text-emerald-500" />,
      };
    case 'Pembelian':
      return {
        label: 'Pembelian',
        className:
          'bg-rose-50 text-rose-700 dark:bg-rose-950/50 dark:text-rose-300 border border-rose-200 dark:border-rose-800/70',
        icon: <IconArrowDownRight size={13} className="text-rose-500" />,
      };
    case 'Setor_Tunai':
      return {
        label: 'Setor Tunai',
        className:
          'bg-teal-50 text-teal-700 dark:bg-teal-950/50 dark:text-teal-300 border border-teal-200 dark:border-teal-800/70',
        icon: <IconArrowUpRight size={13} className="text-teal-500" />,
      };
    case 'Tarik_Tunai':
      return {
        label: 'Tarik Tunai',
        className:
          'bg-amber-50 text-amber-700 dark:bg-amber-950/50 dark:text-amber-300 border border-amber-200 dark:border-amber-800/70',
        icon: <IconArrowDownRight size={13} className="text-amber-500" />,
      };
    case 'Refund_Penjualan':
    case 'Return_Penjualan':
    case 'Return Penjualan':
    case 'RETURN PENJUALAN':
      return {
        label: 'Return Penjualan',
        className:
          'bg-indigo-50 text-indigo-700 dark:bg-indigo-950/50 dark:text-indigo-300 border border-indigo-200 dark:border-indigo-800/70',
        icon: <IconArrowsExchange size={13} className="text-indigo-500" />,
      };
    case 'Refund_Pembelian':
    case 'Return_Pembelian':
    case 'Return Pembelian':
    case 'RETURN PEMBELIAN':
      return {
        label: 'Return Pembelian',
        className:
          'bg-orange-50 text-orange-700 dark:bg-orange-950/50 dark:text-orange-300 border border-orange-200 dark:border-orange-800/70',
        icon: <IconArrowsExchange size={13} className="text-orange-500" />,
      };
    default:
      return {
        label: tipe || 'Transaksi',
        className:
          'bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300 border border-slate-200 dark:border-slate-700',
        icon: null,
      };
  }
};

export default function HistorySaldo() {
  DinamicTitle('Saldo KAS');
  const navigate = useNavigate();

  const [history, setHistory] = useState([]);
  const [totalSaldo, setTotalSaldo] = useState(0);
  const [cabang, setCabang] = useState([]);
  const [saldoCabang, setSaldoCabang] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  // Filters
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const awal = startDate ? moment(startDate).format("DD-MM-YYYY") : "";
  const akhir = endDate ? moment(endDate).format("DD-MM-YYYY") : "";
  const selectionRange = { startDate: startDate || new Date(), endDate: endDate || new Date(), key: "selection" };
  function handleSelect(date) { setStartDate(date.selection.startDate); setEndDate(date.selection.endDate); }
  const [search, setSearch] = useState('');
  const [idCabang, setIdCabang] = useState('');
  const [tipe, setTipe] = useState('');

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);

  // Modals
  const [isOpenTambahSaldo, setIsOpenTambahSaldo] = useState(false);
  const [isOpenModalCabangMobile, setIsOpenModalCabangMobile] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [detailSaldoKas, setDetailSaldoKas] = useState({});
  const [loadingSaldo, setLoadingSaldo] = useState(false);

  function closeModalTambahSaldo() {
    setIsOpenTambahSaldo(false);
  }

  function openModalTambahSaldo() {
    setIsOpenTambahSaldo(true);
  }

  function submitTambahSaldoKas() {
    setRefreshKey((prev) => prev + 1);
  }

  function closeModal() {
    setIsOpen(false);
  }

  const getHistory = useCallback(async () => {
    setLoading(true);
    try {
      const res = await http.get(
        `/history/saldo?page=${currentPage}&cabang=${idCabang}&tipe=${tipe}${startDate && endDate ? "&tgl_awal=" + awal + "&tgl_akhir=" + akhir : ""}`,
        {
          headers: { Authorization: getAuthorizationHeader() },
        }
      );
      setSaldoCabang(res.data?.saldo_cabang || []);
      setTotalSaldo(res.data?.total_saldo || 0);
      setCurrentPage(res.data?.current_page || 1);
      const parsedLastPage =
        typeof res.data?.last_page === 'number'
          ? res.data.last_page
          : typeof res.data?.last_page_url === 'number'
          ? res.data.last_page_url
          : 1;
      setLastPage(parsedLastPage);
      setHistory(res.data?.data || []);
    } catch (err) {
      if (!err.response) {
        return null;
      } else if (err.response.status === 401) {
        navigate('/login');
      }
    } finally {
      setLoading(false);
    }
  }, [currentPage, idCabang, tipe, startDate, endDate, awal, akhir, navigate]);

  useEffect(() => {
    getHistory();
  }, [getHistory, refreshKey]);

  useEffect(() => {
    async function getSaldoCabangList() {
      try {
        const res = await http.get('/cabang?is_toko=1', {
          headers: { Authorization: getAuthorizationHeader() },
        });
        setCabang(res.data?.data || []);
      } catch (err) {
        if (!err.response) {
          return null;
        } else if (err.response.status === 401) {
          navigate('/login');
        }
      }
    }
    getSaldoCabangList();
  }, [navigate]);

  async function getDetailSaldoKAS(id) {
    setLoadingSaldo(true);
    try {
      const res = await http.get(`/history/saldo/${id}`, {
        headers: { Authorization: getAuthorizationHeader() },
      });
      setDetailSaldoKas(res.data?.data || {});
      setIsOpen(true);
    } catch (err) {
      if (!err.response) {
        return null;
      } else if (err.response.status === 401) {
        navigate('/login');
      }
    } finally {
      setLoadingSaldo(false);
    }
  }

  function numberWithCommas(x) {
    if (x === null || x === undefined || isNaN(x)) return '0';
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  const handleCabangFilter = (selectedId) => {
    if (String(idCabang) === String(selectedId)) {
      setIdCabang('');
    } else {
      setIdCabang(selectedId);
    }
    setCurrentPage(1);
  };

  const handleTipeFilter = (selectedTipe) => {
    setTipe(selectedTipe);
    setCurrentPage(1);
  };

  const handleResetFilters = () => {
    setSearch('');
    setIdCabang('');
    setTipe('');
    setStartDate(null);
    setEndDate(null);
    setCurrentPage(1);
  };

  const isFiltered = Boolean(search || idCabang || tipe || startDate || endDate);

  const filteredHistory = history.filter((item) => {
    if (!search) return true;
    const query = search.toLowerCase();
    const matchFaktur = item.kode_trx?.toLowerCase().includes(query);
    const matchCabang = item.cabang?.toLowerCase().includes(query);
    const matchTipe = item.tipe?.toLowerCase().includes(query);
    return matchFaktur || matchCabang || matchTipe;
  });

  return (
    <Layouts
      title="Saldo KAS"
      compFilter={
        <div className="flex items-center gap-2">
          {/* Quick Add Saldo */}
          <button
            type="button"
            onClick={openModalTambahSaldo}
            className="inline-flex items-center gap-1.5 px-3 py-1.5 sm:px-3.5 sm:py-2 rounded-xl bg-amber-500 hover:bg-amber-600 active:bg-amber-700 text-white font-bold text-xs sm:text-sm shadow-sm transition-all active:scale-95 cursor-pointer"
          >
            <IconPlus size={16} />
            <span className="hidden sm:inline">Setor / Tarik Saldo</span>
            <span className="sm:hidden">Setor / Tarik</span>
          </button>

          {/* Quick Mobile Store Balance Drawer Trigger */}
          <button
            type="button"
            onClick={() => setIsOpenModalCabangMobile(true)}
            className="lg:hidden inline-flex items-center gap-1.5 px-3 py-1.5 rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-200 hover:bg-slate-100 dark:hover:bg-slate-700 text-xs font-semibold shadow-sm transition-all"
          >
            <IconBuildingStore size={16} className="text-amber-500" />
            <span>Saldo Toko</span>
          </button>
        </div>
      }
    >
      {/* Global detail loading indicator */}
      {loadingSaldo && (
        <div className="fixed inset-0 z-50 overflow-hidden bg-slate-900/40 backdrop-blur-xs flex flex-col items-center justify-center">
          <div className="w-12 h-12 rounded-full animate-spin border-4 border-amber-500 border-t-transparent shadow-lg" />
        </div>
      )}

      <div className="p-4 sm:p-6 lg:p-8 w-full max-w-full space-y-6">
        {/* Main Grid: Left Column for Balances, Right Column for Mutasi & Filters */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 items-start">
          {/* ========================================================================= */}
          {/* LEFT COLUMN: TOTAL SALDO & SALDO PER CABANG (LG: 4 COLS)                  */}
          {/* ========================================================================= */}
          <div className="lg:col-span-4 xl:col-span-3 space-y-4">
            {/* Card 1: Total Saldo Kas Utama */}
            <div className="bg-white dark:bg-slate-900 border border-slate-200/80 dark:border-slate-800 rounded-2xl p-5 shadow-sm">
              <div className="flex items-center justify-between mb-3">
                <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-lg text-xs font-bold bg-amber-500/10 dark:bg-amber-400/15 text-amber-700 dark:text-amber-300 border border-amber-500/20">
                  Total Saldo
                </span>
                <Tooltip title="Muat Ulang Data">
                  <button
                    type="button"
                    onClick={() => {
                      getHistory();
                      setRefreshKey((k) => k + 1);
                    }}
                    className="p-2 rounded-xl text-slate-400 hover:text-amber-600 dark:hover:text-amber-400 hover:bg-amber-50 dark:hover:bg-slate-800 transition-colors"
                  >
                    <IconRefresh size={18} className={loading ? 'animate-spin' : ''} />
                  </button>
                </Tooltip>
              </div>

              <div className="text-2xl sm:text-3xl font-black text-slate-800 dark:text-slate-100 tracking-tight">
                Rp {numberWithCommas(totalSaldo)}
              </div>

              {/* Setor / Tarik Saldo CTA Button */}
              <button
                type="button"
                onClick={openModalTambahSaldo}
                className="mt-4 w-full py-2.5 px-4 rounded-xl bg-amber-500 hover:bg-amber-600 active:bg-amber-700 text-white font-bold text-xs sm:text-sm shadow-sm hover:shadow transition-all flex items-center justify-center gap-2 cursor-pointer active:scale-95"
              >
                <IconArrowAutofitRight size={18} />
                <span>Setor / Tarik Saldo</span>
              </button>
            </div>

            {/* Card 2: Saldo Per Cabang / Etalase (Visible directly on Desktop) */}
            <div className="hidden lg:block bg-white dark:bg-slate-900 border border-slate-200/80 dark:border-slate-800 rounded-2xl p-5 shadow-sm">
              <div className="space-y-2.5 max-h-[460px] overflow-y-auto pr-1 scrollbar-thin">
                {saldoCabang.length === 0 ? (
                  <div className="text-center py-6 text-slate-400 text-xs">
                    Tidak ada data saldo cabang
                  </div>
                ) : (
                  saldoCabang.map((cb) => {
                    const isSelected = String(idCabang) === String(cb.cabang_id || cb.id);
                    return (
                      <div
                        key={cb.id}
                        onClick={() => handleCabangFilter(cb.cabang_id || cb.id)}
                        className={`p-3 rounded-xl border transition-all cursor-pointer flex items-center justify-between ${
                          isSelected
                            ? 'bg-amber-50/80 dark:bg-amber-950/40 border-amber-400 dark:border-amber-500 shadow-xs'
                            : 'bg-slate-50/80 dark:bg-slate-800/60 border-slate-200/80 dark:border-slate-700/80 hover:border-amber-300 dark:hover:border-amber-600'
                        }`}
                      >
                        <div className="flex items-center gap-2.5 min-w-0">
                          <div
                            className={`w-8 h-8 rounded-lg flex items-center justify-center shrink-0 ${
                              isSelected
                                ? 'bg-amber-500 text-white'
                                : 'bg-white dark:bg-slate-700 text-slate-600 dark:text-slate-300 border border-slate-200 dark:border-slate-600'
                            }`}
                          >
                            <IconBuildingStore size={16} />
                          </div>
                          <div className="truncate">
                            <span className="text-xs font-bold text-slate-800 dark:text-slate-200 block truncate">
                              {cb.cabang?.nama_cabang || 'Toko'}
                            </span>
                            <span className="text-[11px] text-slate-500 dark:text-slate-400">
                              {isSelected ? 'Klik untuk reset filter' : 'Klik untuk filter'}
                            </span>
                          </div>
                        </div>

                        <div className="text-right shrink-0">
                          <div className="text-xs sm:text-sm font-extrabold text-slate-800 dark:text-slate-100">
                            Rp {numberWithCommas(cb.saldo)}
                          </div>
                          {isSelected && (
                            <span className="inline-flex items-center gap-1 text-[10px] font-bold text-amber-600 dark:text-amber-400">
                              <IconCheck size={12} /> Aktif
                            </span>
                          )}
                        </div>
                      </div>
                    );
                  })
                )}
              </div>
            </div>
          </div>

          {/* ========================================================================= */}
          {/* RIGHT COLUMN: SEARCH, FILTER, AND MUTASI LEDGER (LG: 8 COLS)             */}
          {/* ========================================================================= */}
          <div className="lg:col-span-8 xl:col-span-9 space-y-4">
            {/* Filter & Search Bar Card */}
            <div className="bg-white dark:bg-slate-900 border border-slate-200/80 dark:border-slate-800 rounded-2xl p-4 shadow-sm">
              <div className="flex flex-col md:flex-row md:items-center justify-between gap-3">
                {/* Search Input */}
                <div className="relative flex-1">
                  <IconSearch
                    size={18}
                    className="absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-400 pointer-events-none"
                  />
                  <input
                    type="text"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    placeholder="Cari kode faktur / transaksi..."
                    className="w-full pl-10 pr-9 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-slate-800 dark:text-slate-100 text-xs sm:text-sm focus:outline-none focus:ring-2 focus:ring-amber-500/30 focus:border-amber-500 transition-all placeholder:text-slate-400"
                  />
                  {search && (
                    <button
                      onClick={() => setSearch('')}
                      type="button"
                      className="absolute right-3 top-1/2 -translate-y-1/2 p-1 text-slate-400 hover:text-slate-600 dark:hover:text-slate-200"
                    >
                      <IconX size={15} />
                    </button>
                  )}
                </div>

                {/* Filter Dropdowns */}
                <div className="flex flex-wrap items-center gap-2">
                  {/* Select Etalase */}
                  <div className="relative">
                    <select
                      value={idCabang}
                      onChange={(e) => handleCabangFilter(e.target.value)}
                      className="px-3 py-2.5 pr-8 rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-slate-800 dark:text-slate-100 text-xs font-semibold focus:outline-none focus:ring-2 focus:ring-amber-500/30 focus:border-amber-500 transition-all cursor-pointer appearance-none"
                    >
                      <option value="">Semua Etalase</option>
                      {cabang.map((cb) => (
                        <option key={cb.id} value={cb.id}>
                          {cb.nama_cabang}
                        </option>
                      ))}
                    </select>
                    <IconBuildingStore
                      size={14}
                      className="absolute right-2.5 top-1/2 -translate-y-1/2 text-slate-400 pointer-events-none"
                    />
                  </div>

                  {/* Select Tipe Transaksi */}
                  <div className="relative">
                    <select
                      value={tipe}
                      onChange={(e) => handleTipeFilter(e.target.value)}
                      className="px-3 py-2.5 pr-8 rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-slate-800 dark:text-slate-100 text-xs font-semibold focus:outline-none focus:ring-2 focus:ring-amber-500/30 focus:border-amber-500 transition-all cursor-pointer appearance-none"
                    >
                      <option value="">Semua Tipe</option>
                      <option value="Penjualan">Penjualan</option>
                      <option value="Pembelian">Pembelian</option>
                      <option value="Refund_Penjualan">Return Penjualan</option>
                      <option value="Return Pembelian">Return Pembelian</option>
                      <option value="Setor_Tunai">Setor Tunai</option>
                      <option value="Tarik_Tunai">Tarik Tunai</option>
                    </select>
                    <IconFilter
                      size={14}
                      className="absolute right-2.5 top-1/2 -translate-y-1/2 text-slate-400 pointer-events-none"
                    />
                  </div>

                  {/* Filter Tanggal */}
                  <div className="dropdown dropdown-bottom dropdown-end">
                    <div
                      tabIndex={0}
                      className="border border-slate-200 dark:border-slate-700 rounded-xl px-3 py-2.5 text-xs font-semibold text-slate-700 dark:text-slate-100 bg-slate-50 dark:bg-slate-800 cursor-pointer hover:border-amber-300 dark:hover:border-amber-500 focus:border-amber-400 focus:ring-2 focus:ring-amber-100 dark:focus:ring-amber-900/30 transition-all flex items-center gap-1.5 shadow-xs whitespace-nowrap"
                      title="Filter Tanggal"
                    >
                      <IconCalendarTime size={14} className="text-amber-500 shrink-0" />
                      <span>
                        {startDate && endDate && awal !== 'Invalid date'
                          ? (awal === akhir ? awal : awal + " - " + akhir)
                          : 'Pilih Tanggal'}
                      </span>
                    </div>
                    <div tabIndex={0} className="dropdown-content menu p-2 shadow-2xl bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 z-[9999] mt-1 ">
                      <DateRange ranges={[selectionRange]} onChange={handleSelect} />
                      {startDate && (
                        <div className="p-2 border-t border-slate-200 dark:border-slate-700 flex justify-end">
                          <button
                            type="button"
                            onClick={() => {
                              setStartDate(null);
                              setEndDate(null);
                            }}
                            className="text-xs text-rose-500 hover:underline font-bold cursor-pointer"
                          >
                            Reset Tanggal
                          </button>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Reset Filter Button */}
                  {isFiltered && (
                    <button
                      type="button"
                      onClick={handleResetFilters}
                      className="px-3 py-2.5 rounded-xl border border-rose-200 dark:border-rose-900/60 bg-rose-50 dark:bg-rose-950/40 text-rose-600 dark:text-rose-400 hover:bg-rose-100 text-xs font-bold transition-all flex items-center gap-1.5 cursor-pointer active:scale-95"
                    >
                      <IconX size={14} />
                      <span>Reset</span>
                    </button>
                  )}
                </div>
              </div>
            </div>

            {/* Riwayat Mutasi Saldo Kas Ledger Table Card */}
            <div className="bg-white dark:bg-slate-900 border border-slate-200/80 dark:border-slate-800 rounded-2xl shadow-sm overflow-hidden flex flex-col">
              {/* Table / Loading / Empty Content */}
              {loading ? (
                <div className="flex flex-col items-center justify-center py-16 text-slate-500 dark:text-slate-400 gap-3">
                  <div className="w-10 h-10 rounded-full animate-spin border-3 border-amber-500 border-t-transparent shadow-sm" />
                  <span className="text-xs font-semibold">Memuat riwayat saldo kas...</span>
                </div>
              ) : filteredHistory.length === 0 ? (
                <div className="flex flex-col items-center justify-center py-16 px-4 text-center">
                  <div className="w-14 h-14 rounded-3xl bg-slate-100 dark:bg-slate-800 flex items-center justify-center text-slate-400 dark:text-slate-500 mb-3">
                    <IconReceiptTax size={26} />
                  </div>
                  <h4 className="text-sm font-bold text-slate-700 dark:text-slate-200">
                    Tidak Ada Catatan Transaksi
                  </h4>
                  <p className="text-xs text-slate-400 dark:text-slate-500 max-w-xs mt-1">
                    {isFiltered
                      ? 'Tidak ada data yang sesuai dengan filter atau kata kunci pencarian Anda.'
                      : 'Belum ada transaksi saldo kas yang tercatat pada sistem.'}
                  </p>
                  {isFiltered && (
                    <button
                      type="button"
                      onClick={handleResetFilters}
                      className="mt-3 px-4 py-2 rounded-xl bg-slate-100 dark:bg-slate-800 hover:bg-slate-200 text-slate-700 dark:text-slate-300 text-xs font-bold transition-all cursor-pointer"
                    >
                      Reset Filter
                    </button>
                  )}
                </div>
              ) : (
                <div className="overflow-x-auto">
                  <table className="w-full text-left border-collapse">
                    <thead>
                      <tr className="bg-slate-50/80 dark:bg-slate-800/80 border-b border-slate-100 dark:border-slate-800 text-[11px] font-bold uppercase tracking-wider text-slate-600 dark:text-slate-300">
                        <th className="py-3 px-4 whitespace-nowrap w-12 text-center">No</th>
                        <th className="py-3 px-4 whitespace-nowrap">Kode Faktur</th>
                        <th className="py-3 px-4 whitespace-nowrap">Nominal</th>
                        <th className="py-3 px-4 whitespace-nowrap">Saldo Akhir</th>
                        <th className="py-3 px-4 whitespace-nowrap">Tipe</th>
                        <th className="py-3 px-4 whitespace-nowrap">Etalase</th>
                        <th className="py-3 px-4 whitespace-nowrap">Tanggal</th>
                        <th className="py-3 px-4 whitespace-nowrap text-center">Aksi</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-100 dark:divide-slate-800 text-xs">
                      {filteredHistory.map((hs, i) => {
                        const tipeBadge = getTipeBadge(hs.tipe);
                        const rowNominal = hs.nominal !== undefined && hs.nominal !== null ? hs.nominal : hs.saldo_awal;
                        return (
                          <tr
                            key={hs.id || i}
                            onClick={() => getDetailSaldoKAS(hs.id)}
                            className="hover:bg-amber-500/5 dark:hover:bg-amber-500/10 transition-colors cursor-pointer group"
                          >
                            <td className="py-3.5 px-4 text-center font-semibold text-slate-400 dark:text-slate-500">
                              {(currentPage - 1) * 15 + (i + 1)}.
                            </td>
                            <td className="py-3.5 px-4 whitespace-nowrap">
                              <span className="font-mono font-bold text-amber-600 dark:text-amber-400 group-hover:underline">
                                {hs.kode_trx || '-'}
                              </span>
                            </td>
                            <td className="py-3.5 px-4 whitespace-nowrap font-bold text-slate-800 dark:text-slate-100">
                              Rp {numberWithCommas(rowNominal)}
                            </td>
                            <td className="py-3.5 px-4 whitespace-nowrap font-extrabold text-amber-700 dark:text-amber-300">
                              Rp {numberWithCommas(hs.saldo_akhir)}
                            </td>
                            <td className="py-3.5 px-4 whitespace-nowrap">
                              <span
                                className={`inline-flex items-center gap-1 px-2.5 py-0.5 rounded-lg text-[11px] font-bold ${tipeBadge.className}`}
                              >
                                {tipeBadge.icon}
                                {tipeBadge.label}
                              </span>
                            </td>
                            <td className="py-3.5 px-4 whitespace-nowrap">
                              <span className="inline-flex items-center gap-1 text-slate-700 dark:text-slate-300 font-semibold">
                                <IconBuildingStore size={13} className="text-slate-400" />
                                {hs.cabang || '-'}
                              </span>
                            </td>
                            <td className="py-3.5 px-4 whitespace-nowrap text-slate-500 dark:text-slate-400 font-medium">
                              {hs.tanggal || '-'}
                            </td>
                            <td className="py-3.5 px-4 whitespace-nowrap text-center">
                              <button
                                type="button"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  getDetailSaldoKAS(hs.id);
                                }}
                                className="p-1.5 rounded-lg bg-slate-100 dark:bg-slate-800 hover:bg-amber-500 hover:text-white dark:hover:bg-amber-500 dark:hover:text-white text-slate-500 dark:text-slate-400 transition-colors"
                                title="Lihat Detail"
                              >
                                <IconEye size={15} />
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}

              {/* Table Footer: Pagination */}
              <div className="p-4 border-t border-slate-100 dark:border-slate-800 bg-slate-50/50 dark:bg-slate-900/50 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs">
                <div className="text-slate-500 dark:text-slate-400 font-medium">
                  Halaman <span className="font-bold text-slate-700 dark:text-slate-200">{currentPage}</span>{' '}
                  dari <span className="font-bold text-slate-700 dark:text-slate-200">{lastPage || 1}</span>
                </div>

                <div className="flex items-center gap-1.5">
                  <button
                    type="button"
                    onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                    disabled={currentPage <= 1 || loading}
                    className="inline-flex items-center gap-1 px-3 py-1.5 rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 hover:bg-slate-100 dark:hover:bg-slate-700 text-slate-700 dark:text-slate-200 font-semibold disabled:opacity-40 disabled:pointer-events-none transition-all cursor-pointer"
                  >
                    <IconChevronLeft size={16} />
                    <span>Sebelumnya</span>
                  </button>

                  <button
                    type="button"
                    onClick={() => setCurrentPage((prev) => prev + 1)}
                    disabled={(lastPage && currentPage >= lastPage) || loading}
                    className="inline-flex items-center gap-1 px-3 py-1.5 rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 hover:bg-slate-100 dark:hover:bg-slate-700 text-slate-700 dark:text-slate-200 font-semibold disabled:opacity-40 disabled:pointer-events-none transition-all cursor-pointer"
                  >
                    <span>Selanjutnya</span>
                    <IconChevronRight size={16} />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Detail Saldo Kas Modal */}
      <DetailSaldoKas
        detailSaldoKas={detailSaldoKas}
        isOpen={isOpen}
        closeModal={closeModal}
      />

      {/* Tambah Saldo Kas Modal */}
      <TambahSaldoKAS
        submitTambahSaldoKas={submitTambahSaldoKas}
        cabang={cabang}
        isOpenTambahSaldo={isOpenTambahSaldo}
        closeModalTambahSaldo={closeModalTambahSaldo}
      />

      {/* Mobile Drawer / Modal: Saldo Per Toko */}
      <Transition appear show={isOpenModalCabangMobile} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-50 lg:hidden"
          onClose={() => setIsOpenModalCabangMobile(false)}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm transition-opacity" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white dark:bg-slate-900 border border-slate-200/80 dark:border-slate-800 p-5 text-left align-middle shadow-2xl transition-all">
                  <div className="flex items-center justify-between pb-3 border-b border-slate-100 dark:border-slate-800 mb-4">
                    <div className="flex items-center gap-2">
                      <div className="w-8 h-8 rounded-xl bg-amber-500/10 text-amber-600 dark:text-amber-400 flex items-center justify-center">
                        <IconBuildingStore size={18} />
                      </div>
                      <Dialog.Title
                        as="h3"
                        className="text-base font-bold text-slate-800 dark:text-slate-100"
                      >
                        Saldo Per Etalase Toko
                      </Dialog.Title>
                    </div>
                    <button
                      type="button"
                      onClick={() => setIsOpenModalCabangMobile(false)}
                      className="p-1 rounded-lg text-slate-400 hover:text-slate-600 dark:hover:text-slate-200"
                    >
                      <IconX size={18} />
                    </button>
                  </div>

                  <div className="space-y-2 max-h-[60vh] overflow-y-auto pr-1">
                    {saldoCabang.map((cb) => {
                      const isSelected = String(idCabang) === String(cb.cabang_id || cb.id);
                      return (
                        <div
                          key={cb.id}
                          onClick={() => {
                            handleCabangFilter(cb.cabang_id || cb.id);
                            setIsOpenModalCabangMobile(false);
                          }}
                          className={`p-3 rounded-xl border flex items-center justify-between transition-all cursor-pointer ${
                            isSelected
                              ? 'bg-amber-50 dark:bg-amber-950/40 border-amber-400 dark:border-amber-500'
                              : 'bg-slate-50 dark:bg-slate-800/80 border-slate-200 dark:border-slate-700'
                          }`}
                        >
                          <div className="truncate">
                            <span className="text-xs font-bold text-slate-800 dark:text-slate-200 block truncate">
                              {cb.cabang?.nama_cabang || 'Toko'}
                            </span>
                            <span className="text-[11px] text-slate-400">
                              {isSelected ? 'Filter aktif (klik utk lepas)' : 'Klik untuk filter'}
                            </span>
                          </div>
                          <div className="text-right">
                            <div className="text-xs sm:text-sm font-extrabold text-slate-800 dark:text-slate-100">
                              Rp {numberWithCommas(cb.saldo)}
                            </div>
                            {isSelected && (
                              <span className="text-[10px] font-bold text-amber-600 dark:text-amber-400">
                                Aktif
                              </span>
                            )}
                          </div>
                        </div>
                      );
                    })}
                  </div>

                  <div className="mt-4 pt-3 border-t border-slate-100 dark:border-slate-800 flex justify-end">
                    <button
                      type="button"
                      onClick={() => setIsOpenModalCabangMobile(false)}
                      className="w-full py-2 rounded-xl bg-slate-100 dark:bg-slate-800 hover:bg-slate-200 dark:hover:bg-slate-700 text-slate-700 dark:text-slate-200 text-xs font-bold"
                    >
                      Tutup
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </Layouts>
  );
}
